import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ServiceCard = ({ service, onLearnMore }) => {
  return (
    <div className="bg-card rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 flex flex-col h-full">
      <div className="relative h-48 md:h-56 lg:h-64 overflow-hidden">
        <Image
          src={service?.image}
          alt={service?.imageAlt}
          className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
        />
        <div className="absolute top-4 right-4 bg-accent text-white px-3 py-1 rounded-full text-xs md:text-sm font-semibold">
          {service?.category}
        </div>
      </div>
      <div className="p-4 md:p-6 flex flex-col flex-grow">
        <div className="flex items-start gap-3 mb-3 md:mb-4">
          <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name={service?.icon_name || service?.icon} size={24} color="var(--color-primary)" />
          </div>
          <div className="flex-grow min-w-0">
            <h3 className="text-lg md:text-xl font-bold text-foreground mb-1 line-clamp-2">
              {service?.title}
            </h3>
            <p className="text-xs md:text-sm text-muted-foreground">
              {service?.subtitle}
            </p>
          </div>
        </div>

        <p className="text-sm md:text-base text-muted-foreground mb-4 md:mb-6 line-clamp-3 flex-grow">
          {service?.description}
        </p>

        <div className="space-y-3 md:space-y-4 mb-4 md:mb-6">
          {(service?.capabilities || []).slice(0, 3).map((cap, index) => (
            <div key={index} className="flex items-center gap-2 text-xs md:text-sm">
              <Icon name="CheckCircle2" size={16} className="text-success flex-shrink-0" />
              <span className="text-foreground line-clamp-1">{cap}</span>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-between pt-4 border-t border-border mt-auto">
          <div className="flex items-center gap-2">
            <Icon name="TrendingUp" size={16} className="text-accent" />
            <span className="text-xs md:text-sm font-semibold text-foreground whitespace-nowrap">
              {service?.project_count || service?.projectCount} Projects
            </span>
          </div>
          <button
            onClick={() => onLearnMore(service)}
            className="px-4 py-2 bg-primary hover:bg-primary/90 text-white rounded-lg text-xs md:text-sm font-semibold transition-all duration-200 flex items-center gap-2 whitespace-nowrap"
          >
            Learn More
            <Icon name="ArrowRight" size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;